import React from "react";

const ProgressBar = ({ 
  score, 
  thresholds = [], 
  labels = [], 
  colors = [] 
}) => {
  // Calculate total segments and position based on score
  const totalSegments = thresholds.length + 1;

  // Determine which segment the score falls into
  const getSegmentIndex = () => {
    for (let i = 0; i < thresholds.length; i++) {
      if (score < thresholds[i]) {
        return i;
      }
    }
    return thresholds.length; // Last segment
  };

  const segmentIndex = getSegmentIndex();
  const arrowPosition = ((segmentIndex + 0.5) / totalSegments) * 100 + "%";

  return (
    <div style={{ position: "relative", width: "100%" }}>
      {/* Progress Bar */}
      <div
        style={{
          display: "flex",
          height: "30px",
          width: "100%",
          borderRadius: "10px",
          overflow: "hidden",
        }}
      >
        {Array.from({ length: totalSegments }, (_, index) => (
          <div
            key={index}
            style={{
              flex: 1,
              backgroundColor: colors[index] || "#cccccc",
            }}
          ></div>
        ))}
      </div>

      {/* Moving Arrow */}
      <div
        style={{
          position: "absolute",
          top: "-10px",
          left: arrowPosition,
          transform: "translateX(-50%)",
          transition: "left 0.5s ease-in-out",
          width: "0",
          height: "0",
          borderLeft: "10px solid transparent",
          borderRight: "10px solid transparent",
          borderTop: "10px solid black",
        }}
      ></div>

      {/* Labels */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "10px",
          fontSize: "14px",
          color: "black",
        }}
      >
        {labels.map((label, index) => (
          <div
            key={index}
            style={{ textAlign: "center", flex: 1 }}
          >
            {label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
